import { useQuery } from 'react-query';
import { apiPaths } from '.';

/*
// replace in useGetSettings for development
async function fetchStaticSettings() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        staticFilesHost: 'https://qadra-public-assets.s3-eu-west-1.amazonaws.com',
        translationsPath: '/translations/staging',
        sentryDsn: 'https://5e21b90eda7d49858ed6e6d1302e6289@o581298.ingest.sentry.io/5757286',
        environment: 'development',
      });
    }, 500);
  });
}
*/

async function fetchSettings() {
  try {
    const res = await fetch(apiPaths.settings);
    return await res.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('There was an error loading the settings:', error);
    return {};
  }
}

export function useGetSettings() {
  return useQuery('settings', fetchSettings);
}
